import { useMutation, useQueryClient } from 'react-query';
import { authFetch } from '../../../../CommonUtils/authFetch';
import { httpBodyOptions } from '../../../../CommonUtils/httpBodyOptions';
import { queryKeys } from './queryKeys';
import { FirmSettingsDTO } from './useFirmSettingsQuery';

const saveFirmSettings = async (params: FirmSettingsDTO) => {
  return authFetch('/Adviser/Settings/Firm', {
    method: 'POST',
    ...httpBodyOptions(params, true),
  });
};

export const useSaveFirmSettingsMutation = () => {
  const queryClient = useQueryClient();

  return useMutation(saveFirmSettings, {
    onSuccess() {
      queryClient.refetchQueries(queryKeys.firmSettings());
    },
  });
};
